import { request } from '@/request'
import {
  SET_RECEITAS_PROPRIAS,
  SET_DETALHAMENTO_DESPESAS,
  SET_GRUPO_DESPESAS,
  SET_FUNCAO_SUBFUNCAO,
  SET_ADIANTAMENTOS,
  SET_DESPESAS_DETALHADAS,
  SET_ANO_BASE
} from './types'

const geosiapApi = (ano, grupo) => {
  const base = 'https://geosiap.santos.sp.gov.br/portal-transparencia/api/default/execucao'
  return {
    receitas_proprias: `${base}/receitas/proprias/receitas_proprias?ano=${ano.getFullYear()}&dt_inicial=undefined&dt_final=undefined&id_entidade=1&dias=0&layout=Anual`,
    detalhamento_despesas: `${base}/detalhamento_despesas/detalhamento_despesas?ano=${ano.getFullYear()}&id_entidade=1&dias=0`,
    grupo_despesas: `${base}/despesas_acao/despesas_acao?id_entidade=1&tipo_despesa=${grupo}&ano_selecionado=${ano}&data_inicial=undefined&data_final=undefined`,
    adiantamentos: `${base}/adiantamentos/adiantamentos?dt_inicial=${new Date(ano.getFullYear(),0, 1)}&dt_final=${ano}&id_entidade=1&dias=0`,
    despesas_detalhadas: `${base}/despesas_detalhadas/despesas_detalhadas?ano=${ano}&data_inicial=undefined&data_final=undefined&id_entidade=1&filtro=undefined`,
  }
}

const retornaData = (store) => {
  const { ano_base } = store.state
  const data_atual = new Date()

  if (ano_base !== data_atual.getFullYear()) {
    return new Date(ano_base, 11, 31, 23, 59, 59)
  }

  return data_atual
}

export const actions = {
  async atualizaAnoBase (store, ano) {
    store.commit(SET_ANO_BASE, ano)
    store.dispatch('loadReceitasProprias')
    store.dispatch('loadDetalhamentoDespesas')
    store.dispatch('loadGrupoDespesas')
    store.dispatch('loadFuncaoSubfuncao')
    await store.dispatch('loadDespesasDetalhadas')
    return true
  },

  loadReceitasProprias (store) {
    return new Promise((resolve, reject) => {
      request.get(
        geosiapApi(retornaData(store)).receitas_proprias
      )
      .then(response => {
        store.commit(SET_RECEITAS_PROPRIAS, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  },

  loadDetalhamentoDespesas (store) {
    return new Promise((resolve, reject) => {
      request.get(
        geosiapApi(retornaData(store)).detalhamento_despesas
      )
      .then(response => {
        store.commit(SET_DETALHAMENTO_DESPESAS, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  },

  loadGrupoDespesas (store) {
    return new Promise((resolve, reject) => {
      request.get(
        geosiapApi(retornaData(store), 'uo').grupo_despesas
      )
      .then(response => {
        store.commit(SET_GRUPO_DESPESAS, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  },

  loadFuncaoSubfuncao (store) {
    return new Promise((resolve, reject) => {
      request.get(
        geosiapApi(retornaData(store), 'fs').grupo_despesas
      )
      .then(response => {
        store.commit(SET_FUNCAO_SUBFUNCAO, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  },

  loadAdiantamentos (store) {
    return new Promise((resolve, reject) => {
      request.get(
        geosiapApi(retornaData(store)).adiantamentos
      )
      .then(response => {
        store.commit(SET_ADIANTAMENTOS, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  },

  loadDespesasDetalhadas (store) {
    return new Promise((resolve, reject) => {
      request.get(
        geosiapApi(retornaData(store)).despesas_detalhadas
      )
      .then(response => {
        store.commit(SET_DESPESAS_DETALHADAS, response.data)
        resolve(response)
      })
      .catch(error => reject(error))
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/receitas_despesas/actions.js